import React, { Component } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';

import Cookies from 'js-cookie';
import { global } from './../config.js';
import { getParamURL } from './functions';

class Auth extends Component {

    constructor(props) {
        super(props);
        this.state = {
            username: "",
            password: "",
            loading: false,
            error: false,
            results: []
        };

        this.handleChangeUsername = this.handleChangeUsername.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    componentDidMount(){
        let token = Cookies.get('session-acs');
        if (token)
            window.location.replace("/")
    }

    auth() {
        
        const { username, password } = this.state

        if (username === '' || username === '')
            return;

        this.setState({
            loading: true,
            error: false
        })

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({username, password})
        };

        fetch(global.endpoint_api + '/user/auth', requestOptions)
            .then(res => res.json()).then(
            (result) => {
    
                if (result.error) {
                    this.setState({
                        error: result.error.message
                    });
                } else if (result.token) {
                    Cookies.set('session-acs', result.token);
                    let redirect = getParamURL('partner_uid');
                    let uri = "/"
                    if (redirect) uri = redirect
                    window.location.replace(uri)
                } else {
                    this.setState({
                        error: "Ошибка авторизации. Пожалуйста, попробуйте позже."
                    });
                }
    
                this.setState({
                    loading: false,
                    results: result
                });
            },
            (error) => {}
        )

    }

    handleChangeUsername(event) {
        this.setState({username: event.target.value});
    }

    handleChangePassword(event) {
        this.setState({password: event.target.value});
    }

    handleSubmit(event) {
        this.auth()
        event.preventDefault()
      }

    
    render() {

        return (
            <Container className="d-flex min-vh-100 align-items-center justify-content-center">
                <Row className="">
                    <Col>
                        <div className="Auth-form-container">
                            <form className="Auth-form" onSubmit={this.handleSubmit}>
                                <div className="Auth-form-content">
                                    <h3 className="Auth-form-title">Авторизация</h3>
                                    <div className="form-group mt-3">
                                        <input
                                            type="text"
                                            className="form-control mt-1"
                                            placeholder="Логин или email"
                                            value={this.state.username}
                                            onChange={this.handleChangeUsername}
                                        />
                                    </div>
                                    <div className="form-group mt-3">
                                        <input
                                            type="password"
                                            className="form-control mt-1"
                                            placeholder="Пароль"
                                            value={this.state.password}
                                            onChange={this.handleChangePassword}
                                        />
                                    </div>
                                    <div className="d-grid gap-2 mt-3">
                                        <Button type="submit" disabled={this.state.loading} variant="dark">
                                            Войти
                                        </Button>
                                    </div>
                                    <div className="block-error mt-2">
                                        {this.state.error && <div className="text-center text-danger"><small>{this.state.error}</small></div>}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </Col>
                </Row>
            </Container>
            
        )
    }
}

export default Auth;